import { useEffect, useRef, useState } from "react";

// Plays video only when scrolled into view; avoids preloading/autoplaying
// all homepage videos at once (major mobile Speed Index + bandwidth win).
const LazyVideo = ({ src, className, poster }) => {
  const ref = useRef(null);
  const videoRef = useRef(null);
  const [inView, setInView] = useState(false);

  // Observe visibility — only flips state, never touches the media here.
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { rootMargin: "200px", threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  // Play/pause AFTER the render that sets the src has committed, so the
  // browser actually has a source to load (fixes the black, never-loading box).
  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    if (inView) {
      v.load();
      v.play().catch(() => {});
    } else {
      v.pause();
    }
  }, [inView]);

  return (
    <div ref={ref} className="w-full h-full">
      <video
        ref={videoRef}
        src={inView ? src : undefined}
        poster={poster}
        className={className}
        muted
        loop
        playsInline
        autoPlay
        preload="metadata"
      />
    </div>
  );
};

export default LazyVideo;
